import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { Subject } from 'rxjs';
import { NotifyCodeNoAction } from 'app-models';
import * as errorUtils from 'error-message-utility';
import { getSubTaskDetails } from 'visa-store';
import * as i1$1 from 'primeng/dynamicdialog';
import * as i3 from 'ngx-toastr';
import * as i4 from '@angular/router';
import * as i5 from '@ngrx/store';
import * as i6 from 'primeng/tabview';
import * as i7 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i8 from '@angular/common';
import * as i9 from 'primeng/inputtextarea';
import * as i10 from 'primeng/divider';
import * as i11 from 'primeng/button';
import * as i12 from 'primeng/dropdown';
import * as i13 from 'notification-view';
import { NotificationViewModule } from 'notification-view';
import { PrimengLibraryModule } from 'primeng-library';

class SendNotificationService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    postNotification(payload) {
        return this.httpClient.post(`/notification/save`, payload).pipe(map((response) => response));
    }
}
SendNotificationService.ɵfac = function SendNotificationService_Factory(t) { return new (t || SendNotificationService)(i0.ɵɵinject(i1.HttpClient)); };
SendNotificationService.ɵprov = i0.ɵɵdefineInjectable({ token: SendNotificationService, factory: SendNotificationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendNotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function SendNotificationComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.notification.selectedReceiverType.name);
} }
function SendNotificationComponent_ng_template_19_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SendNotificationComponent_ng_template_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SendNotificationComponent_ng_template_19_div_1_span_1_Template, 2, 1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r0.controls["selectedReceiverType"].errors == null ? null : _r0.controls["selectedReceiverType"].errors.required);
} }
function SendNotificationComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdown", 26);
    i0.ɵɵlistener("ngModelChange", function SendNotificationComponent_ng_template_19_Template_p_dropdown_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.notification.selectedReceiverType = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(1, SendNotificationComponent_ng_template_19_div_1_Template, 2, 1, "div", 19);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(13);
    i0.ɵɵproperty("options", ctx_r2.receiversList)("filter", false)("ngModel", ctx_r2.notification.selectedReceiverType)("disabled", ctx_r2.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r0.controls["selectedReceiverType"].touched && _r0.controls["selectedReceiverType"].invalid);
} }
function SendNotificationComponent_div_24_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
function SendNotificationComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SendNotificationComponent_div_24_span_1_Template, 2, 1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r0.controls["message"].errors == null ? null : _r0.controls["message"].errors.required);
} }
const _c0 = function () { return { "width": "250px" }; };
function SendNotificationComponent_p_tabPanel_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-tabPanel", 29);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelement(2, "lib-notification-view", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("headerStyle", i0.ɵɵpureFunction0(3, _c0));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("viewFrom", "task")("inputData", ctx_r5.notificationView);
} }
class SendNotificationComponent {
    constructor(dynamicDialogRef, dynamicDialogConfig, sendNotificationService, toastr, router, store) {
        this.dynamicDialogRef = dynamicDialogRef;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.sendNotificationService = sendNotificationService;
        this.toastr = toastr;
        this.router = router;
        this.store = store;
        this.observableSubscription$ = new Subject();
        this.index = 0;
        this.isNotificationView = false;
        this.disabledControls = false;
        this.receiversList = [];
        this.notification = {
            selectedReceiverType: null,
            message: '',
        };
        this.userType = sessionStorage.getItem('userTypeRole');
    }
    ngOnInit() {
        // Get Specific Task Details
        if (this.dynamicDialogConfig.data.beneficiary) {
            this.receiversList.push(this.dynamicDialogConfig.data.beneficiary);
            this.notification.selectedReceiverType = this.dynamicDialogConfig.data.beneficiary;
        }
        else {
            this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                if (data) {
                    this.subTaskDetails = data;
                    if (this.userType !== 'Beneficiary' && this.subTaskDetails.beneficiaryDetails) {
                        // Adding Beneficiary to list
                        this.receiversList.push({ name: `${this.subTaskDetails.beneficiaryDetails.firstName} ${this.subTaskDetails.beneficiaryDetails.lastName}`, type: 'BENEFICIARY', employeeId: this.subTaskDetails.beneficiaryDetails.id, companyId: this.subTaskDetails.companyId });
                    }
                    else if (this.userType !== 'Beneficiary' && this.dynamicDialogConfig.data.caseType &&
                        this.dynamicDialogConfig.data.caseType === 'I130' && this.subTaskDetails.familyFirstName &&
                        this.subTaskDetails.familyLastName && this.subTaskDetails.familyId) {
                        this.receiversList.push({
                            name: `${this.subTaskDetails.sponsorFirstName} ${this.subTaskDetails.sponsorLastName}`,
                            type: 'BENEFICIARY',
                            employeeId: this.subTaskDetails.sponsorId,
                            companyId: this.subTaskDetails.companyId
                        });
                    }
                    if (this.dynamicDialogConfig.data.caseType !== 'I130') {
                        if (this.userType !== 'Petitioner' && this.subTaskDetails.preparePetitionerName) {
                            // Adding Petitioner to list
                            this.receiversList.push({
                                name: this.subTaskDetails.preparePetitionerName,
                                type: 'PETITIONER',
                                employeeId: this.subTaskDetails.immSpecialistId,
                                companyId: this.subTaskDetails.companyId
                            });
                        }
                        if (this.userType !== 'Attorney' && this.subTaskDetails.preparerAttorneyName) {
                            // Adding Attorney to list
                            this.receiversList.push({
                                name: this.subTaskDetails.preparerAttorneyName,
                                type: 'ATTORNEY',
                                companyId: this.subTaskDetails.attorneyId,
                                employeeId: this.subTaskDetails.preparerAttorneyId
                            });
                        }
                    }
                    if (this.receiversList && this.receiversList.length === 1) {
                        this.notification.selectedReceiverType = this.receiversList[0];
                    }
                }
            });
        }
        if (this.router.url.indexOf('/dashboard/superTask/task-details/') > -1) {
            this.isNotificationView = true;
            this.store.select(getSubTaskDetails).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                if (data) {
                    this.notificationView = data;
                }
            });
        }
        else {
            this.isNotificationView = false;
        }
    }
    handleClose() {
        // this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
        //   if (response) {
        this.dynamicDialogRef.close();
        //   }
        //   else {
        //     return false;
        //   }
        // });
    }
    postSendNotification() {
        const payload = {
            beneficiaryId: this.notification.selectedReceiverType['type'] === 'BENEFICIARY' ?
                this.notification.selectedReceiverType['employeeId'] : null,
            channelType: 'APP',
            companyId: this.notification.selectedReceiverType['companyId'],
            data: this.dynamicDialogConfig.data.beneficiary ? null : `{"superTaskId": ${this.subTaskDetails.superTaskId}}`,
            employeeId: (this.notification.selectedReceiverType['type'] === 'PETITIONER' || this.notification.selectedReceiverType['type'] === 'ATTORNEY') ? this.notification.selectedReceiverType['employeeId'] : null,
            id: null,
            notificationType: this.dynamicDialogConfig.data.beneficiary ? NotifyCodeNoAction.ADD_DEPENDENT : NotifyCodeNoAction.TASK_AUDIT,
            notifyAllBeneficiaries: false,
            notifyAllEmployees: false,
            priority: '',
            text: this.notification.message,
            title: `${this.dynamicDialogConfig.data.caseType === 'I130' ?
                this.dynamicDialogConfig.data.caseType : this.dynamicDialogConfig.data.superTaskTypeCode
                === 'IMMPET' ? this.dynamicDialogConfig.data.immigrationCategoryName : this.dynamicDialogConfig.data.visaName} Activity`
        };
        this.sendNotificationService.postNotification(payload).subscribe((response) => {
            if (response.status === 200) {
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleCancel() {
        this.dynamicDialogRef.close();
    }
}
SendNotificationComponent.ɵfac = function SendNotificationComponent_Factory(t) { return new (t || SendNotificationComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig), i0.ɵɵdirectiveInject(SendNotificationService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.Router), i0.ɵɵdirectiveInject(i5.Store)); };
SendNotificationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SendNotificationComponent, selectors: [["lib-send-notification"]], decls: 31, vars: 12, consts: [[1, "fluid-container"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-11", "step-title", "p-0"], [1, "mb-0"], [1, "col-md-1", "pr-0", "d-flex", "justify-content-end"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["id", "notificationSettings"], [3, "activeIndex", "activeIndexChange"], ["header", "Send Notification", 3, "headerStyle"], [1, "tabViewPortion"], [1, "pb-3", "pt-2", 3, "ngSubmit"], ["sendNotificationForm", "ngForm"], [1, "row", "mb-3"], [1, "col-md-4", "form-group", "processing-dropdown"], [1, "label-cls", "required", "d-block"], [3, "ngIf"], [1, "col-md-12", "form-group"], ["type", "text", "name", "message", "placeholder", "Type Message", "pInputTextarea", "", 1, "im-input", "mw-100", 3, "readOnly", "ngModel", "ngModelChange"], ["message", "ngModel"], [4, "ngIf"], [1, "row", "pt-3"], [1, "col-md-12"], ["pButton", "", "type", "submit", "label", "Send", "title", "Send", "icon", "pi pi-save", 1, "pull-right", 3, "ngClass", "disabled"], ["pButton", "", "type", "button", "label", "Cancel", "icon", "pi pi-times-circle", 1, "pull-right", "p-button-secondary", "cancel-btn", "button-width-icon-left", "d-flex", "alogn-items-center", "mr-3", 3, "disabled", "click"], ["header", "List of notifications", 3, "headerStyle", 4, "ngIf"], [1, "label-dark"], ["name", "selectedReceiverType", "optionLabel", "name", "placeholder", "Select Receiver", "required", "", 3, "options", "filter", "ngModel", "disabled", "ngModelChange"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], ["header", "List of notifications", 3, "headerStyle"], [3, "viewFrom", "inputData"]], template: function SendNotificationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5", 3);
        i0.ɵɵelementStart(4, "b");
        i0.ɵɵtext(5, "Notification");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "i", 5);
        i0.ɵɵlistener("click", function SendNotificationComponent_Template_i_click_7_listener() { return ctx.handleClose(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "p-tabView", 7);
        i0.ɵɵlistener("activeIndexChange", function SendNotificationComponent_Template_p_tabView_activeIndexChange_9_listener($event) { return ctx.index = $event; });
        i0.ɵɵelementStart(10, "p-tabPanel", 8);
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵelementStart(12, "form", 10, 11);
        i0.ɵɵlistener("ngSubmit", function SendNotificationComponent_Template_form_ngSubmit_12_listener() { return ctx.postSendNotification(); });
        i0.ɵɵelementStart(14, "div", 12);
        i0.ɵɵelementStart(15, "div", 13);
        i0.ɵɵelementStart(16, "label", 14);
        i0.ɵɵtext(17, "To");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, SendNotificationComponent_ng_template_18_Template, 2, 1, "ng-template", 15);
        i0.ɵɵtemplate(19, SendNotificationComponent_ng_template_19_Template, 2, 5, "ng-template", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 12);
        i0.ɵɵelementStart(21, "div", 16);
        i0.ɵɵelementStart(22, "textarea", 17, 18);
        i0.ɵɵlistener("ngModelChange", function SendNotificationComponent_Template_textarea_ngModelChange_22_listener($event) { return ctx.notification.message = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, SendNotificationComponent_div_24_Template, 2, 1, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(25, "p-divider");
        i0.ɵɵelementStart(26, "div", 20);
        i0.ɵɵelementStart(27, "div", 21);
        i0.ɵɵelement(28, "button", 22);
        i0.ɵɵelementStart(29, "button", 23);
        i0.ɵɵlistener("click", function SendNotificationComponent_Template_button_click_29_listener() { return ctx.handleCancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(30, SendNotificationComponent_p_tabPanel_30_Template, 3, 4, "p-tabPanel", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(13);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("activeIndex", ctx.index);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("headerStyle", i0.ɵɵpureFunction0(11, _c0));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.receiversList && ctx.receiversList.length === 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.receiversList && ctx.receiversList.length > 1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("readOnly", ctx.disabledControls)("ngModel", ctx.notification.message);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", _r0.controls["message"].touched && _r0.controls["message"].invalid);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", _r0.invalid || ctx.disabledControls ? "btn-success button-width-icon-left btn-success_disabled" : "btn-success button-width-icon-left")("disabled", _r0.invalid || ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isNotificationView);
    } }, directives: [i6.TabView, i6.TabPanel, i7.ɵangular_packages_forms_forms_ba, i7.NgControlStatusGroup, i7.NgForm, i8.NgIf, i7.DefaultValueAccessor, i9.InputTextarea, i7.NgControlStatus, i7.NgModel, i10.Divider, i11.ButtonDirective, i8.NgClass, i12.Dropdown, i7.RequiredValidator, i13.NotificationViewComponent], styles: [".save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.cancel-btn[_ngcontent-%COMP%]{border-radius:10px;text-transform:uppercase;font-size:12px;font-weight:700;padding:10px}.cancel-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:20px;padding:2px}.tabViewPortion[_ngcontent-%COMP%]{min-height:450px;max-height:450px;overflow-y:auto;padding:15px!important;background-color:#f2f2f2}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendNotificationComponent, [{
        type: Component,
        args: [{
                selector: 'lib-send-notification',
                templateUrl: './send-notification.component.html',
                styleUrls: ['./send-notification.component.scss']
            }]
    }], function () { return [{ type: i1$1.DynamicDialogRef }, { type: i1$1.DynamicDialogConfig }, { type: SendNotificationService }, { type: i3.ToastrService }, { type: i4.Router }, { type: i5.Store }]; }, null); })();

class SendNotificationModule {
}
SendNotificationModule.ɵfac = function SendNotificationModule_Factory(t) { return new (t || SendNotificationModule)(); };
SendNotificationModule.ɵmod = i0.ɵɵdefineNgModule({ type: SendNotificationModule });
SendNotificationModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            NotificationViewModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SendNotificationModule, { declarations: [SendNotificationComponent], imports: [PrimengLibraryModule,
        FormsModule,
        NotificationViewModule], exports: [SendNotificationComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendNotificationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SendNotificationComponent
                ],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    NotificationViewModule,
                ],
                exports: [
                    SendNotificationComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of send-notification
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SendNotificationComponent, SendNotificationModule, SendNotificationService };
//# sourceMappingURL=send-notification.js.map
